<template>
  <v-text-field
    ref="numberInput"
    v-bind="$attrs"
    :validate-on-blur="validateOnBlur"
    :outlined="outlined"
    :dense="dense"
    autocomplete="off"
    type="number"
    inputmode="numeric"
    color="black"
    background-color="white"
    v-on="$listeners"
  >
    <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
    <template #message="{ message }">
      {{ $t(message) }}
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "DefaultNumberField",
  inheritAttrs: false,
  props: {
    dense: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    validateOnBlur: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
